import React from 'react';
import { Rubyversum } from './pages/Rubyversum';
export function App() {
  return <Rubyversum data-id="element-0" />;
}